import { useContext, useState, useEffect } from "react";
import { navigate } from "raviger";
import axios from "axios";
import { Button, Card, Col, FormControl, InputGroup, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleLeft, faMinusSquare
} from '@fortawesome/free-solid-svg-icons';
import Header from "../components/Header";
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import LoadingLink from '../components/LoadingLink';
import ActionsDropdown from '../components/ActionsDropdown';

function IncidentUserManagement({ id, organization }) {

  const { dispatch, state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [data, setData] = useState({users: [], isFetching: false});
  const [incidentData, setIncidentData] = useState({id: null, name:''});
  const [filteredData, setFilteredData] = useState({users: [], isFetching: false});

  const [userToDelete, setUserToDelete] = useState({id: 0, first_name: '', last_name: ''});
  const [showUserConfirm, setShowUserConfirm] = useState(false);
  const handleUserClose = () => setShowUserConfirm(false);

  const [timer, setTimer] = useState(null);

	const handleRemoveUserSubmit = async () => {
  	await axios.delete('/accounts/api/user/' + userToDelete.id + '/?organization=' + state.organization.id + '&incident=' + id)
    .then(response => {
      setData(prevState => ({ ...prevState, "users":data.users.filter(user => user.id !== userToDelete.id) }));
      setFilteredData(prevState => ({ ...prevState, "users":data.users.filter(user => user.id !== userToDelete.id) }));
      setUserToDelete({id: 0, first_name: '', last_name: ''});
      handleUserClose();
    })
    .catch(error => {
      setShowSystemError(true);
    });
  }

  // Use a delay for quick search
  function changeDelay(searchTerm) {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        handleSearch(searchTerm);
      }, 1000)
    );
  }

  // Update searchTerm when field input changes.
  const handleSearch = (searchTerm) => {
    if (searchTerm) {
      setFilteredData(prevState => ({ ...prevState,
        "users":data.users.filter(user => (user.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                  user.last_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                  user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                  user.cell_phone.toLowerCase().includes(searchTerm.toLowerCase()))
      ) }));
    }
    else {
      setFilteredData(prevState => ({ ...prevState, "users":data.users }));
    }
  };

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    if (state.organization.id) {
      const fetchUserData = async () => {

        setData({users: [], isFetching: true});
        axios.get('/accounts/api/user/?organization=' + state.organization.id + '&incident=' + id, {
          cancelToken: source.token,
        })
        .then(response => {
          if (!unmounted) {
            setData({users: response.data, isFetching: false});
            setFilteredData({users: response.data, isFetching: false});
          }
        })
        .catch(error => {
          if (!unmounted) {
            setData({users: [], isFetching: false});
            setShowSystemError(true);
          }
        });

        // Cleanup.
        return () => {
          unmounted = true;
          source.cancel();
        };
      }

      const fetchIncident = async () => {
        // Fetch Visit Note data.
        await axios.get('/incident/api/incident/' + id + '/', {
          cancelToken: source.token,
        })
        .then(response => {
          if (!unmounted) {
            setIncidentData(response.data);
          }
        })
        .catch(error => {
          if (!unmounted) {
            setShowSystemError(true);
          }
        });
      };
      fetchUserData();
      fetchIncident();
    }
  }, [state.organization.id]);

  return (
    <>
    {state.user.is_superuser || state.user.user_perms ?
    <span className="mt-4 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
    <Header>
      <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization + '/manage/incidents')} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
      {state.organization.name} - {incidentData.name} - Manage Incident Access
    </Header>
    <InputGroup className="mb-3">
      <FormControl
        type="text"
        placeholder="Quick Search..."
        name="searchTerm"
        onChange={(event) => {
          changeDelay(event.target.value);
        }}
      />
    </InputGroup>
    <h4>Individual Access</h4>
    {filteredData.users.filter(user =>
        !user.is_superuser &&
        !(
          (incidentData.training && user.all_training) ||
          (!incidentData.training && user.all_operational)
        )
      ).length ? 
    <Row className="flex-nowrap">
      <Col style={{minWidth:"125px", maxWidth:"125px", marginLeft:"0px"}}>
          Access Type
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px", marginLeft:"0px"}}>
          Last Name
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px", marginLeft:"1px"}}>
          First Name
      </Col>
      <Col style={{minWidth:"300px", maxWidth:"300px"}}>
          Email
      </Col>
      <Col style={{minWidth:"150px", maxWidth:"150px"}}>
          Phone
      </Col>
      <Col style={{minWidth:"100px", maxWidth:"100px"}}>
          Actions
      </Col>
    </Row> : 
    <p>No users have individual access to this incident.</p>}
    {filteredData.users.filter(user =>
        !user.is_superuser &&
        !(
          (incidentData.training && user.all_training) ||
          (!incidentData.training && user.all_operational)
        )
      ).map(user => (
      <Card key={user.id} className="rounded mb-1 ms-2" style={{height:"32px", maxWidth:"741px"}}>
        <div className="row no-gutters flex-nowrap me-0">
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", borderTopLeftRadius:"0.25rem", borderBottomLeftRadius:"0.25rem", minWidth:"125px", maxWidth:"125px", backgroundColor:"#615e5e"}}>
            Individual
          </Col>
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"125px", maxWidth:"125px", backgroundColor:"#615e5e"}}>
            {user.last_name}
          </Col>
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"125px", maxWidth:"125px", backgroundColor:"#615e5e"}}>
            {user.first_name}
          </Col>
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"300px", maxWidth:"300px", backgroundColor:"#615e5e"}}>
            {user.email}
          </Col>
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"150px", maxWidth:"150px", backgroundColor:"#615e5e"}}>
            {user.display_phone}
          </Col>
          <Col className="border" style={{height:"32px", paddingRight:"3px", paddingTop:"2px", marginTop: "-1px", fontSize:"13px", minWidth:"100px", maxWidth:"100px", borderTopRightRadius:"0.25rem", borderBottomRightRadius:"0.25rem", borderTopRightRadius:"0.25rem", borderBottomRightRadius:"0.25rem", backgroundColor:"#615e5e"}}>
						<ActionsDropdown variant="secondary" title={"Actions"} className="float-end" style={{height:"26px", paddingTop:"0px"}}>
							<LoadingLink
								onClick={() => {setUserToDelete({id:user.id, first_name: user.first_name, last_name: user.last_name});setShowUserConfirm(true);}}
								className="d-block"
								isLoading={false}
								label="Remove User"
								disabled={(incidentData.training && user.all_training) || (!incidentData.training && user.all_operational)}
								disabled_text={user.all_training ? "User access may not be removed because the user has All Training permission." : "User access may not be removed because the user has All Operational permission."}
								>
								<FontAwesomeIcon icon={faMinusSquare} className="fas" inverse />
							</LoadingLink>
						</ActionsDropdown>
          </Col>
        </div>
      </Card>
    ))}
    <p className="phr"/>
    <h4>{incidentData.training ? "All Training " : "All Operational "}Access</h4>
    {filteredData.users.filter(user =>
        !user.is_superuser &&
        (
          (incidentData.training && user.all_training) ||
          (!incidentData.training && user.all_operational)
        )
      ).length ? 
    <Row className="flex-nowrap">
      <Col style={{minWidth:"125px", maxWidth:"125px", marginLeft:"0px"}}>
          Access Type
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px", marginLeft:"0px"}}>
          Last Name
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px", marginLeft:"1px"}}>
          First Name
      </Col>
      <Col style={{minWidth:"300px", maxWidth:"300px"}}>
          Email
      </Col>
      <Col style={{minWidth:"150px", maxWidth:"150px"}}>
          Phone
      </Col>
      <Col style={{minWidth:"100px", maxWidth:"100px"}}>
          Actions
      </Col>
    </Row> : 
    <p>No users have all {incidentData.training ? "training " : " operational"} access to this incident.</p>}
    {filteredData.users
      .filter(user =>
        !user.is_superuser &&
        (
          (incidentData.training && user.all_training) ||
          (!incidentData.training && user.all_operational)
        )
      ).map(user => (
      <Card key={user.id} className="rounded mb-1 ms-2" style={{height:"32px", maxWidth:"741px"}}>
        <div className="row no-gutters flex-nowrap me-0">
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", borderTopLeftRadius:"0.25rem", borderBottomLeftRadius:"0.25rem", minWidth:"125px", maxWidth:"125px", backgroundColor:"#615e5e"}}>
            All
          </Col>
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"125px", maxWidth:"125px", backgroundColor:"#615e5e"}}>
            {user.last_name}
          </Col>
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"125px", maxWidth:"125px", backgroundColor:"#615e5e"}}>
            {user.first_name}
          </Col>
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"300px", maxWidth:"300px", backgroundColor:"#615e5e"}}>
            {user.email}
          </Col>
          <Col className="border-top border-start border-bottom" style={{height:"32px", paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"150px", maxWidth:"150px", backgroundColor:"#615e5e"}}>
            {user.display_phone}
          </Col>
          <Col className="border" style={{height:"32px", paddingRight:"3px", paddingTop:"2px", marginTop: "-1px", fontSize:"13px", minWidth:"100px", maxWidth:"100px", borderTopRightRadius:"0.25rem", borderBottomRightRadius:"0.25rem", borderTopRightRadius:"0.25rem", borderBottomRightRadius:"0.25rem", backgroundColor:"#615e5e"}}>
            <ActionsDropdown variant="secondary" title={"Actions"} className="float-end" style={{height:"26px", paddingTop:"0px"}}>
              <LoadingLink
                onClick={() => {setUserToDelete({id:user.id, first_name: user.first_name, last_name: user.last_name});setShowUserConfirm(true);}}
                className="d-block"
                isLoading={false}
                label="Remove User"
                disabled={(incidentData.training && user.all_training) || (!incidentData.training && user.all_operational)}
                disabled_text={user.all_training ? "User access may not be removed because the user has All Training permission." : "User access may not be removed because the user has All Operational permission."}
                >
                <FontAwesomeIcon icon={faMinusSquare} className="fas" inverse />
              </LoadingLink>
            </ActionsDropdown>
          </Col>
        </div>
      </Card>
    ))}
    </span> : ""}
    <Modal show={showUserConfirm} onHide={handleUserClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm User Removal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you would like to remove access to this incident from user {userToDelete.first_name} {userToDelete.last_name}?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleRemoveUserSubmit}>Yes</Button>
        <Button variant="secondary" onClick={handleUserClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

export default IncidentUserManagement
